// ─────────────────────────────────────────────────────────────
// SITE SETTINGS — the only file you may ever need to edit.
// Everything below appears on the public website.
// ─────────────────────────────────────────────────────────────

export const SITE = {
  name: "Cotswold Drone Mapping",
  tagline: "Land. Mapped. Understood.",
  // Add your business email between the quotes when ready, e.g. "hello@yourdomain.co.uk"
  // Until then the website shows the enquiry form as the way to reach you.
  email: "",
  base: "Based near Cirencester",
  areas: ["Cotswolds", "Gloucestershire", "Oxfordshire", "Wiltshire"],
};

// Free contact-form delivery (Web3Forms).
// 1. Go to https://web3forms.com and enter your email to get a free access key.
// 2. Add it to the file frontend/.env as:  REACT_APP_WEB3FORMS_KEY=your-key-here
// Until a key is added the form runs in clearly-labelled demonstration mode.
export const WEB3FORMS_KEY = process.env.REACT_APP_WEB3FORMS_KEY || "";

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1749192901200-a7d8df57b0fe?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwzfHxhZXJpYWwlMjBmaWVsZHMlMjBnb2xkZW4lMjBob3VyfGVufDB8fHx8MTc5MzAyMzcyMXww&ixlib=rb-4.1.0&q=85",
  estate: "https://images.unsplash.com/photo-1758612120966-b20c01160c7b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwyfHxjb3VudHJ5JTIwZXN0YXRlJTIwYWVyaWFsfGVufDB8fHx8MTc5MzAyMzcyMXww&ixlib=rb-4.1.0&q=85",
  fields: "https://images.unsplash.com/photo-1781816928185-0978e391ea5c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwzfHxjb3VudHJ5JTIwZXN0YXRlJTIwYWVyaWFsfGVufDB8fHx8MTc5MzAyMzcyMXww&ixlib=rb-4.1.0&q=85",
  stoneWall: "https://images.unsplash.com/photo-1696262787603-55c8b36f198c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHw0fHxkcnklMjBzdG9uZSUyMHdhbGwlMjBwcm9wZXJ0eXxlbnwwfHx8fDE3OTMwMjM3MjF8MA&ixlib=rb-4.1.0&q=85",
};

export const NAV = [
  { label: "Services", to: "/services" },
  { label: "How It Works", to: "/how-it-works" },
  { label: "Example Work", to: "/example-work" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export const PROJECT_TYPES = [
  "Estate overview",
  "Field or site mapping",
  "Aerial imagery / visual record",
  "Progress or change monitoring",
  "Mapping support for a professional",
  "Not sure yet",
];
